export const webPortfolioData = [
  {
    id: 1,
    name: "Ohana Events",
    url: "https://ohanaevents.app",
    description: "Events app for the Salesforce community: an iOS app on the App Store plus a web app, connecting admins, developers, partners, and customers across ecosystem events",
    techStack: ["Expo", "React Native", "FastAPI", "MongoDB"],
    features: ["Persona-Based Discovery", "Host Event Management", "Admin Dashboard"],
    screenshot: "/portfolio/ohana.png",
    category: "Mobile App"
  },
  {
    id: 2,
    name: "Graveyard Shift",
    url: "https://graveyardshift.app",
    status: "In App Store review",
    description: "Horror movie app built for two: swipe apart, match in secret, then watch together",
    techStack: ["React Native", "Expo", "Supabase", "TMDB API"],
    features: ["Blind Swipe Matching", "Streaming Availability", "Curated Horror Catalog"],
    screenshot: "/portfolio/graveyardshift.png",
    category: "Mobile App"
  },
  {
    id: 3,
    name: "Maple DX",
    url: "https://www.mapledx.com",
    description: "2026 redesign for an agentic AI consultancy, with an AI pipeline that researches, scores, and drafts blog posts for approval",
    techStack: ["Next.js", "React", "Tailwind CSS", "Supabase", "Claude API"],
    features: ["AI Blog Pipeline", "Readiness Assessment", "Industry Solution Pages"],
    screenshot: "/portfolio/mapledx.png",
    category: "Enterprise"
  },
  {
    id: 4,
    name: "Stratyx Ventures",
    url: "https://stratyxventures.com",
    description: "2026 rebuild for an AI agents, websites, and apps studio",
    techStack: ["Astro", "TypeScript", "Netlify"],
    features: ["Service & Audience Pages", "Case Studies", "Transparent Pricing"],
    screenshot: "/portfolio/stratyxventures.png",
    category: "AI Automation"
  },
  {
    id: 5,
    name: "Vascent",
    url: "https://vascent.ai",
    description: "Site for an AI strategy and transformation firm that partners with executive teams",
    techStack: ["Astro", "Netlify"],
    features: ["Service Offerings", "Four-Phase Method", "Strategy Session Booking"],
    screenshot: "/portfolio/vascent.png",
    category: "Business Services"
  },
  {
    id: 6,
    name: "Twenty One North",
    url: "https://twentyonenorth.netlify.app",
    description: "Private concierge site for luxury travel in Turks & Caicos",
    techStack: ["HTML", "CSS", "JavaScript"],
    features: ["Experience Catalog", "Sample Itineraries", "Membership Program"],
    screenshot: "/portfolio/twentyonenorth.jpg",
    category: "Travel & Hospitality"
  },
  {
    id: 7,
    name: "Chiip",
    url: "https://www.chiip.app",
    description: "Drink-gifting app for bars, with an iPhone app for guests and a tablet dashboard for bartenders",
    techStack: ["Expo", "React Native", "Next.js", "Supabase"],
    features: ["Drink Gifting", "Bartender Redemption Dashboard", "Venue Management"],
    screenshot: "/portfolio/chiip.png",
    category: "Mobile App"
  },
  {
    id: 8,
    name: "Plexata",
    url: "https://www.plexata.com",
    description: "NFC smart ring platform for instant digital business card sharing and lead capture",
    techStack: ["React", "NFC Technology", "SMS API", "Analytics Dashboard"],
    features: ["NFC Ring Tap-to-Share", "Lead Capture Dashboard", "Auto SMS Follow-ups", "Real-time Analytics"],
    screenshot: "/portfolio/plexata.png",
    category: "Networking Tech"
  },
  {
    id: 9,
    name: "Appraisal Repair",
    url: "https://www.appraisalrepair.com",
    description: "Real estate appraisal platform connecting contractors and property owners",
    techStack: ["React", "Node.js", "PostgreSQL", "Stripe"],
    features: ["Contractor Matching", "Repair Management", "Payment Processing"],
    screenshot: "/portfolio/appraisalrepair.png",
    category: "PropTech"
  },
  {
    id: 10,
    name: "Slushd",
    url: "https://www.slushd.co",
    description: "Festival beverage vendor website with booking system",
    techStack: ["React", "Node.js", "MongoDB", "Email API"],
    features: ["Event Booking", "Flavor Catalog", "Partner Showcase"],
    screenshot: "/portfolio/slushd.png",
    category: "Food & Beverage"
  },
  {
    id: 11,
    name: "Blue Mountain BPO",
    url: "https://www.bluemountainbpo.com",
    description: "Nearshore BPO services platform for Jamaican talent",
    techStack: ["WordPress", "PHP", "MySQL"],
    features: ["Service Showcase", "Talent Pool Management", "Contact System"],
    screenshot: "/portfolio/bluemountainbpo.png",
    category: "Business Services"
  },
  {
    id: 12,
    name: "TPA Auctions",
    url: "https://www.tpaauctions.com",
    description: "Estate auction and real estate services platform",
    techStack: ["WordPress", "WooCommerce", "PHP"],
    features: ["Auction Listings", "Estate Services", "Gallery System"],
    screenshot: "/portfolio/tpaauctions.png",
    category: "Auction Platform"
  },
  {
    id: 13,
    name: "Genii Consultants",
    url: "https://www.geniiconsultants.com",
    description: "Salesforce talent acquisition and staffing platform",
    techStack: ["React", "Node.js", "Salesforce API"],
    features: ["Talent Matching", "Client Portal", "Job Board"],
    screenshot: "/portfolio/geniiconsultants.png",
    category: "Staffing"
  },
  {
    id: 14,
    name: "AllStar CNY",
    url: "https://www.allstarcny.com",
    description: "Sports facility and programs website",
    techStack: ["WordPress", "PHP", "JavaScript"],
    features: ["Program Registration", "Facility Booking", "News & Events"],
    screenshot: "/portfolio/allstarcny.png",
    category: "Sports & Recreation"
  }
];
